import React, { Component } from 'react'
import './Recommandations1.scss'

export default class Recommendations1 extends Component {
    render() {
        return (
            <div id="recommandations1" >
                <h2><strong>Recommandations</strong></h2>
                <div>
                    <h5>Caroline Larcié Campus Manager à la Wild Code School</h5>
                </div>
                <div class="animated bounce delay-2s">
                    <p>Alexandre est un développeur plein d'énergie et d'optimisme qui sait travailler en équipe. De par son ancienne vie de chef d'entreprise, il sait mener à bien un projet client, tant au travers d'une bonne gestion du temps et des impératifs que sur la qualité du travail rendu. Il s'est formé sur JavaScript mais a toutes les compétences et qualités requises pour apprendre rapidement de nouveaux langages, en parfaite autonomie.</p>
                </div>
                <div>
                    <h5>David MARIE React.js Ruby on Rails & Node.JS Developper, Formateur</h5>
                </div>
                <div>
                    <p>Alexandre est un atout dans l'équipe. Bon developpeur et communiquant, il est force de proposition et sais prendre le lead d'une équipe. Lors de la réalisation des projets clients, Alexandre à développé un bon nombre de fonctionnalités en ayant la volonté de produire un code propre et maintenable.</p>
                </div>

                <div>
                    <h5>Guillaume Dieudonné Founder Vaka & LimonX , Formateur</h5>
                </div>
                <div>
                    <p>

J'ai eu l'occasion de travailler avec Alex dans le cadre de sa formation JavaScript à la Wild code School Marseille.

Il a su très rapidement s'approprier des technologies et frameworks complexes tels que React et React Native.

Il a été un élément déterminant dans la livraison des projets de fin d'année et a su évoluer avec beaucoup d'autonomie sur les différents modules du projet (app mobile React Native, back office React et API NodeJs + ExpressJs).

J'ai particulièrement apprécié sa motivation, sa curiosité et sa capacité à s'intégrer dans une équipe tant sur la partie technique que sur la partie communication et management.

De plus, son expérience professionnelle notamment en tant que chef d'entreprise lui ont permis de très rapidement utiliser certaines de ses soft skills au sein d'une équipe de 8 developpeurs dans le cadre des projets de fin d'année.

Alex est sans aucun doute un excellent Dev JS en devenir et je n'ai aucun doute sur sa capacité à créer de la valeur au sein d'une équipe de développeurs. </p>
                </div>
            </div>
        )
    }
}
